import React from "react";
import { FaBell, FaTrash } from "react-icons/fa";

import {
  formatNotificationDate,
  getCategoryLabel,
  getCategoryStyle,
} from "../utils/notificationListUtils";

function NotificationTable({ notifications = [], deletingId, onDelete }) {
  return (
    <section className="hidden overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20 lg:block">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[920px] text-left">
          <thead>
            <tr className="border-b border-slate-200 bg-slate-50 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Message</th>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 dark:divide-white/10">
            {notifications.map((notification) => {
              const style = getCategoryStyle(notification.category);
              const isDeleting = deletingId === notification.id;

              return (
                <tr
                  key={notification.id}
                  className="text-sm transition hover:bg-sky-50/60 dark:hover:bg-white/[0.03]"
                >
                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex min-h-9 items-center gap-2 rounded-2xl px-3 text-xs font-bold ${style.badge}`}
                    >
                      <span className={`h-2 w-2 rounded-full ${style.dot}`} />
                      {getCategoryLabel(notification.category)}
                    </span>
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex items-start gap-3">
                      <div className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
                        <FaBell />
                      </div>

                      <p className="max-w-5xl whitespace-pre-line text-sm font-semibold leading-6 text-slate-700 dark:text-white/70">
                        {notification.message || "Notification sans message"}
                      </p>
                    </div>
                  </td>

                  <td className="whitespace-nowrap px-4 py-3 text-sm font-bold text-slate-500 dark:text-white/50">
                    {formatNotificationDate(notification.created_at)}
                  </td>

                  <td className="px-4 py-3 text-right">
                    <button
                      type="button"
                      onClick={() => onDelete(notification)}
                      disabled={isDeleting}
                      className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
                    >
                      <FaTrash />
                      {isDeleting ? "Suppression..." : "Supprimer"}
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default NotificationTable;